(function(){
  var root = document.querySelector('[data-mc-root]');
  if(!root || root.dataset.mcInit) return;
  root.dataset.mcInit = "1";

  var CFG = { wa: root.getAttribute('data-wa'), ig: root.getAttribute('data-ig') };

  function base(){
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if(r.charAt(r.length-1) !== '/') r += '/';
    return r;
  }
  function handleOf(url){
    if(!url || typeof url !== 'string') return "";
    var p = url.split('/products/')[1];
    return p ? p.split(/[?#]/)[0] : "";
  }

  var MODELS = [];
  var LAYERS = [
    { n:"01", title:"Mecanismo pushback", sub:"Reclinas con el cuerpo", detail:"Te recuestas con el peso del cuerpo, sin palancas ni motores." },
    { n:"02", title:"Espuma de alta densidad", sub:"Acolchado que recupera su forma", detail:"Asiento y respaldo con espuma que vuelve a su lugar." },
    { n:"03", title:"Estructura de madera y metal", sub:"El nucleo que sostiene", detail:"Bastidor interno de madera con refuerzos metalicos en los puntos de carga." }
  ];
  var REELS = [];

  function readJSON(sel){ try { var el = root.querySelector(sel); if(!el) return null; return JSON.parse((el.textContent||'').trim() || 'null'); } catch(e){ return null; } }
  var mj = readJSON('[data-mc-models]');
  if(mj && mj.length){
    MODELS = mj.map(function(m){
      m.colors = (m.colors||[]).filter(function(c){ return c && c.name && (''+c.name).trim(); });
      if(!m.colors.length) m.colors = [{ name:"Unico", hex:"#8B7E6E", img:m.img }];
      if(!m.img && m.colors[0]) m.img = m.colors[0].img;
      m.colors.forEach(function(c){ if(!c.img) c.img = m.img; });
      m.now = Number(m.now)||0; m.was = Number(m.was)||0;
      if(typeof m.url !== 'string') m.url = '';
      if(typeof m.img !== 'string' || !m.img) m.img = '';
      return m;
    });
  }
  var rj = readJSON('[data-mc-reels-data]'); if(rj){ REELS = rj; }
  var lj = readJSON('[data-mc-layers-data]'); if(lj && lj.length){ LAYERS = lj.map(function(l,i){ if(!l.n){ l.n = ("0"+(i+1)).slice(-2); } return l; }); }

  /* Si el bloque no trae un link de producto usable, lo resolvemos desde
     la grilla real de la coleccion que se renderiza mas abajo en la pagina.
     Se empareja por cantidad de plazas (1/2/3 cuerpos). */
  function gridLinks(){
    var out = [];
    root.querySelectorAll('.mc-list__grid a.mc-pcard[href]').forEach(function(a){
      var h = handleOf(a.getAttribute('href'));
      if(h) out.push({ handle:h, text:((a.textContent||'') + ' ' + h).toLowerCase() });
    });
    return out;
  }
  function resolveUrls(){
    var links = gridLinks();
    if(!links.length) return;
    MODELS.forEach(function(m, i){
      if(handleOf(m.url)) return;
      var p = parseInt(m.plazas,10) || 1;
      var pat = new RegExp(p + '[\\s\\-_]*cuerpo');
      var hit = links.filter(function(l){ return pat.test(l.text); })[0];
      if(!hit) hit = links[Math.min(i, links.length-1)];
      if(hit) m.url = '/products/' + hit.handle;
    });
  }

  var state = { model: 0, colors: [], layer: 0 };

  function money(n){ return "$ " + n.toLocaleString("es-AR"); }
  function badge(m){ if(!m.was || m.was <= m.now) return ""; return "-" + Math.round((1 - m.now/m.was)*100) + "%"; }
  function saveMsg(m){ if(!m.was || m.was <= m.now) return ""; var pct = Math.round((1 - m.now/m.was)*100); return "Ahorras " + money(m.was-m.now) + " · " + pct + "% menos"; }
  function dot(t){
    if(t==="black") return "background:linear-gradient(135deg,#3a3530,#15120f);";
    if(t==="brown") return "background:linear-gradient(135deg,#7a5536,#46300f);";
    return "background:linear-gradient(135deg,#bcb6ac,#8c867c);";
  }
  function dotStyle(c){ if(c && c.hex) return "background:"+c.hex+";"; return dot(c && c.t); }
  function esc(s){ if(s===null || s===undefined) return ""; return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(new RegExp(String.fromCharCode(34),'g'),"&quot;"); }

  function sofaIcon(seats){
    var sw=1.7, unit=22, armW=9, pad=2;
    var innerW=seats*unit;
    var W=pad*2+armW*2+innerW;
    var H=40;
    var topY=5, backBot=20, seatTop=17, baseY=31, legH=5, armTopY=11;
    var innerL=pad+armW, innerR=W-pad-armW;
    var s='<svg viewBox="0 0 '+W+' '+H+'" fill="none" stroke="currentColor" stroke-width="'+sw+'" stroke-linecap="round" stroke-linejoin="round" style="height:46px;width:auto;display:block">';
    s+='<rect x="'+innerL+'" y="'+topY+'" width="'+innerW+'" height="'+(backBot-topY)+'" rx="4"/>';
    s+='<rect x="'+innerL+'" y="'+seatTop+'" width="'+innerW+'" height="'+(baseY-seatTop)+'" rx="4"/>';
    for(var i=1;i<seats;i++){ var x=innerL+i*unit; s+='<line x1="'+x+'" y1="'+(seatTop+2)+'" x2="'+x+'" y2="'+(baseY-2)+'"/>'; }
    s+='<rect x="'+pad+'" y="'+armTopY+'" width="'+armW+'" height="'+(baseY-armTopY)+'" rx="4"/>';
    s+='<rect x="'+(W-pad-armW)+'" y="'+armTopY+'" width="'+armW+'" height="'+(baseY-armTopY)+'" rx="4"/>';
    s+='<line x1="'+(innerL+3)+'" y1="'+baseY+'" x2="'+(innerL+3)+'" y2="'+(baseY+legH)+'"/>';
    s+='<line x1="'+(innerR-3)+'" y1="'+baseY+'" x2="'+(innerR-3)+'" y2="'+(baseY+legH)+'"/>';
    s+='</svg>';
    return s;
  }
  function chairIcon(){
    var sw=1.7, pad=3, armW=10, seatW=18;
    var innerL=pad+armW, W=pad*2+armW*2+seatW;
    var H=40;
    var topY=5, backBot=19, seatTop=16, baseY=31, legH=5, armTopY=8;
    var innerR=W-pad-armW;
    var s='<svg viewBox="0 0 '+W+' '+H+'" fill="none" stroke="currentColor" stroke-width="'+sw+'" stroke-linecap="round" stroke-linejoin="round" style="height:46px;width:auto;display:block">';
    s+='<rect x="'+innerL+'" y="'+topY+'" width="'+seatW+'" height="'+(backBot-topY)+'" rx="4"/>';
    s+='<rect x="'+innerL+'" y="'+seatTop+'" width="'+seatW+'" height="'+(baseY-seatTop)+'" rx="4"/>';
    s+='<rect x="'+pad+'" y="'+armTopY+'" width="'+armW+'" height="'+(baseY-armTopY)+'" rx="4"/>';
    s+='<rect x="'+(W-pad-armW)+'" y="'+armTopY+'" width="'+armW+'" height="'+(baseY-armTopY)+'" rx="4"/>';
    s+='<line x1="'+(innerL+3)+'" y1="'+baseY+'" x2="'+(innerL+3)+'" y2="'+(baseY+legH)+'"/>';
    s+='<line x1="'+(innerR-3)+'" y1="'+baseY+'" x2="'+(innerR-3)+'" y2="'+(baseY+legH)+'"/>';
    s+='</svg>';
    return s;
  }
  function modelIcon(m,i){
    var p=parseInt(m.plazas,10);
    if(p>=2) return sofaIcon(p);
    if(i===1) return chairIcon();
    return sofaIcon(1);
  }

  var $chips  = root.querySelector('[data-mc-chips]');
  var $bars   = root.querySelector('[data-mc-bars]');
  var $thumbs = root.querySelector('[data-mc-thumbs]');
  var $detail = root.querySelector('[data-mc-detail]');
  var $layers = root.querySelector('[data-mc-layers]');
  var $reels  = root.querySelector('[data-mc-reels]');

  function renderChips(){
    if(!$chips) return;
    var h = '<span class="lbl">Lo quiero para:</span>';
    MODELS.forEach(function(m,i){
      h += '<button type="button" class="mc-chip" data-mc-model="'+i+'" aria-pressed="'+(i===state.model)+'">'+esc(m.chip)+'</button>';
    });
    $chips.innerHTML = h;
  }
  function renderBars(){
    if(!$bars) return;
    var h = '';
    MODELS.forEach(function(m,i){
      h += '<button type="button" class="mc-barbtn" data-mc-model="'+i+'" aria-pressed="'+(i===state.model)+'">'+modelIcon(m,i)+'<span class="vol">'+esc(m.plazas==='1' ? m.cap+' '+m.label : m.cap)+'</span></button>';
    });
    $bars.innerHTML = h;
  }
  function renderThumbs(){
    if(!$thumbs) return;
    var h = '';
    MODELS.forEach(function(m,i){
      h += '<button type="button" class="mc-thumb" data-mc-model="'+i+'" aria-pressed="'+(i===state.model)+'">'
        + '<span class="mc-thumb__ph"><img src="'+m.img+'" alt="'+esc(m.label)+'" loading="lazy"></span>'
        + '<span class="mc-thumb__meta"><span class="k">'+esc(m.label)+'</span><span class="t">'+esc(m.cap)+'</span></span>'
        + '<span class="mc-thumb__chk"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>'
        + '</button>';
    });
    $thumbs.innerHTML = h;
  }

  function productPath(m){
    var h = handleOf(m && m.url);
    return h ? (base() + 'products/' + h) : '';
  }

  function renderDetail(){
    if(!$detail) return;
    var m = MODELS[state.model];
    if(!m) return;
    var ci = state.colors[state.model] || 0;
    var col = m.colors[ci] || m.colors[0] || { name:"Unico" };
    var bd = badge(m);
    var selImg = col.img || m.img;
    var url = productPath(m);
    var sw = '';
    m.colors.forEach(function(c,i){
      sw += '<button type="button" class="mc-sw" data-mc-color="'+i+'" aria-pressed="'+(i===ci)+'"><span class="dot" style="'+dotStyle(c)+'"></span><span class="nm">'+esc(c.name)+'</span></button>';
    });
    var actions = '<div class="mc-actions">'
      + '<button type="button" class="mc-btn mc-btn--solid mc-atc" data-mc-atc>Agregar al carrito</button>'
      + (url ? '<a class="mc-btn mc-btn--ghost mc-more" href="'+url+'">Ver detalles y fotos</a>' : '')
      + '</div>';
    var h = ''
      + '<div class="mc-detail__media">'
      +   (bd ? '<span class="mc-badge">'+bd+'</span>' : '')
      +   '<img src="'+selImg+'" alt="'+esc(m.label)+'">'
      + '</div>'
      + '<div class="mc-detail__info">'
      +   '<div class="mc-detail__title"><h3>'+esc(m.label)+'</h3><span class="tag">'+esc(m.tag)+'</span></div>'
      +   '<p class="mc-detail__use">'+esc(m.use)+'</p>'
      +   '<div class="mc-opt"><div class="mc-opt__h">Tapizado <b>'+esc(col.name)+'</b></div><div class="mc-sw__row">'+sw+'</div></div>'
      +   '<div class="mc-buy">'
      +     '<div class="mc-price" data-mc-price><span class="now">'+money(m.now)+'</span>'+(m.was>m.now ? '<span class="was">'+money(m.was)+'</span>' : '')+'<span class="msi">Envio gratis · 6 Cuotas sin interés</span></div>'
      +     '<div class="mc-pcard__save" data-mc-save style="margin-top:8px">'+(m.was>m.now ? saveMsg(m) : '')+'</div>'
      +     actions
      +   '</div>'
      +   '<div class="mc-dims"><div><div class="k">Plazas</div><div class="v">'+m.plazas+'</div></div><div><div class="k">Mecanismo</div><div class="v">'+((parseInt(m.plazas,10) >= 2 || /premium/i.test(m.label||'')) ? "Gatillo lateral" : "Pushback")+'</div></div><div><div class="k">Tapizado</div><div class="v">Eco cuero</div></div></div>'
      + '</div>';
    $detail.innerHTML = h;
    hydratePrice(m);
  }

  function hydratePrice(m){
    var handle = handleOf(m.url);
    if(!handle) return;
    hydratePrice._t = handle;
    fetchProduct(handle).then(function(prod){
      if(hydratePrice._t !== handle) return;
      var now = Math.round((prod.price||0)/100);
      var was = Math.round((prod.compare_at_price||0)/100);
      if(!now) return;
      m.now = now; m.was = was > now ? was : 0;
      var pe = $detail.querySelector('[data-mc-price]');
      if(pe){ pe.innerHTML = '<span class="now">'+money(m.now)+'</span>'+(m.was>m.now ? '<span class="was">'+money(m.was)+'</span>' : '')+'<span class="msi">Envio gratis · 6 Cuotas sin interés</span>'; }
      var se = $detail.querySelector('[data-mc-save]');
      if(se){ se.innerHTML = (m.was>m.now ? saveMsg(m) : ''); }
      var be = root.querySelector('.mc-detail__media .mc-badge');
      var bd = badge(m);
      if(be){ if(bd){ be.textContent = bd; } else { be.remove(); } }
    }).catch(function(){});
  }

  var anatCar = null;
  function setActiveLayer(i){
    state.layer = i;
    if(!$layers) return;
    [].forEach.call($layers.querySelectorAll('.mc-zrow'), function(row, ri){
      row.setAttribute('aria-expanded', ri===i ? 'true' : 'false');
    });
  }
  function renderLayers(){
    if(!$layers) return;
    var h = '';
    LAYERS.forEach(function(l,i){
      h += '<button type="button" class="mc-zrow" data-mc-layer="'+i+'" aria-expanded="'+(i===state.layer)+'">'
        + '<span class="n">'+esc(l.n)+'</span>'
        + '<span><span class="t">'+esc(l.title)+'</span><span class="s">'+esc(l.sub)+'</span><span class="d">'+esc(l.detail)+'</span></span>'
        + '</button>';
    });
    $layers.innerHTML = h;
  }
  function renderReels(){
    if(!$reels) return;
    var h = '';
    REELS.forEach(function(r){
      if(r.ig){
        h += '<div class="mc-reel mc-reel--ig">'
          + '<iframe src="'+r.ig+'" loading="lazy" frameborder="0" scrolling="no" allowtransparency="true" allowfullscreen title="'+esc(r.caption||'Reel de Instagram')+'"></iframe>'
          + '</div>';
      } else if(r.video){
        h += '<div class="mc-reel mc-reel--video" data-mc-reel-video tabindex="0" role="button" aria-label="'+esc(r.caption)+'">'
          + '<span class="mc-reel__media"><video src="'+r.video+'"'+(r.img ? ' poster="'+r.img+'"' : '')+' muted loop playsinline preload="metadata" webkit-playsinline></video></span>'
          + '<span class="mc-reel__shade"></span>'
          + '<span class="mc-reel__play"><svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span>'
          + '<span class="mc-reel__cap"><span class="h">'+esc(r.handle)+'</span><span class="c">'+esc(r.caption)+'</span></span>'
          + '</div>';
      } else if(r.img){
        h += '<a class="mc-reel" href="'+CFG.ig+'" target="_blank" rel="noopener">'
          + '<span class="mc-reel__media"><img src="'+r.img+'" alt="'+esc(r.caption)+'" loading="lazy"></span>'
          + '<span class="mc-reel__shade"></span>'
          + '<span class="mc-reel__play"><svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span>'
          + '<span class="mc-reel__cap"><span class="h">'+esc(r.handle)+'</span><span class="c">'+esc(r.caption)+'</span></span>'
          + '</a>';
      }
    });
    $reels.innerHTML = h;
  }

  function toggleReelVideo(el){
    var v = el.querySelector('video');
    if(!v) return;
    if(v.paused){
      root.querySelectorAll('.mc-reel--video video').forEach(function(o){ if(o!==v){ o.pause(); o.closest('.mc-reel--video').classList.remove('is-playing'); } });
      var p = v.play();
      if(p && p.catch){ p.catch(function(){}); }
      el.classList.add('is-playing');
    } else {
      v.pause();
      el.classList.remove('is-playing');
    }
  }

  function renderSelector(){ renderChips(); renderBars(); renderThumbs(); renderDetail(); }

  // ---- Carrito ----------------------------------------------------------
  var productCache = {};

  function colorSyns(name){
    var n = (name||"").toLowerCase();
    if(/negro|black/.test(n)) return ["negro","black"];
    if(/marr|caf|brown|chocolate/.test(n)) return ["marr","caf","brown","chocolate"];
    if(/gris|gray|grey|tela|fabric/.test(n)) return ["gris","gray","grey","tela","fabric"];
    return [];
  }
  function variantText(v){ return ((v.title||"") + " " + ((v.options||[]).join(" "))).toLowerCase(); }
  function pickVariant(prod, colorName){
    var syns = colorSyns(colorName);
    var avail = prod.variants.filter(function(v){ return v.available; });
    var pool = avail.length ? avail : prod.variants;
    if(syns.length){
      var hit = pool.filter(function(v){
        var t = variantText(v);
        return syns.some(function(s){ return t.indexOf(s) !== -1; });
      })[0];
      if(hit) return hit;
    }
    return pool[0];
  }
  function fetchProduct(handle){
    if(productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch(base() + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function(r){ if(!r.ok) throw new Error('no product'); return r.json(); })
      .then(function(p){ productCache[handle] = p; return p; });
  }

  function formAdd(id){
    var f = document.createElement('form');
    f.method = 'post';
    f.action = base() + 'cart/add';
    f.style.display = 'none';
    var i = document.createElement('input'); i.type='hidden'; i.name='id'; i.value=id;
    var q = document.createElement('input'); q.type='hidden'; q.name='quantity'; q.value='1';
    f.appendChild(i); f.appendChild(q);
    document.body.appendChild(f);
    f.submit();
  }

  function addToCart(btn){
    var m = MODELS[state.model];
    if(!m) return;
    if(btn.dataset.busy === "1") return;
    var ci = state.colors[state.model] || 0;
    var colorName = m.colors[ci] ? m.colors[ci].name : "";
    var handle = handleOf(m.url);

    btn.dataset.busy = "1";
    var orig = btn.getAttribute('data-mc-label') || btn.textContent;
    btn.setAttribute('data-mc-label', orig);

    if(!handle){
      btn.dataset.busy = "";
      btn.textContent = "Producto no vinculado";
      setTimeout(function(){ btn.textContent = orig; }, 2500);
      return;
    }

    btn.textContent = "Agregando…";

    fetchProduct(handle).then(function(prod){
      var v = pickVariant(prod, colorName);
      if(!v) throw new Error('no variant');
      return fetch(base() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      }).then(function(r){
        if(r.ok) return r.json();
        formAdd(v.id);
        throw new Error('handled');
      });
    }).then(function(){
      btn.textContent = "Agregado ✓";
      document.dispatchEvent(new CustomEvent('mc:cart:added'));
      window.location.href = base() + 'cart';
    }).catch(function(err){
      btn.dataset.busy = "";
      btn.textContent = orig;
      if(err && err.message === 'handled') return;
      var p = productPath(m);
      if(p) window.location.href = p;
    });
  }

  root.addEventListener('click', function(e){
    var t = e.target;
    if(!t || !t.closest) return;
    var rv = t.closest('[data-mc-reel-video]');
    if(rv && root.contains(rv)){ e.preventDefault(); toggleReelVideo(rv); return; }
    var atc = t.closest('[data-mc-atc]');
    if(atc && root.contains(atc)){ e.preventDefault(); e.stopPropagation(); addToCart(atc); return; }
    var mEl = t.closest('[data-mc-model]');
    if(mEl && root.contains(mEl)){ state.model = parseInt(mEl.getAttribute('data-mc-model'),10); renderSelector(); return; }
    var cEl = t.closest('[data-mc-color]');
    if(cEl && root.contains(cEl)){ state.colors[state.model] = parseInt(cEl.getAttribute('data-mc-color'),10); renderDetail(); return; }
    var lEl = t.closest('[data-mc-layer]');
    if(lEl && root.contains(lEl)){ var li = parseInt(lEl.getAttribute('data-mc-layer'),10); if(anatCar){ anatCar.goTo(li); } else { setActiveLayer(li); } return; }
  });

  function initCarousels(){
    root.querySelectorAll('[data-mc-carousel]').forEach(function(car){
      if(car.dataset.mcCarInit) return;
      car.dataset.mcCarInit = "1";
      var isAnat = !!car.closest('.mc-anat');
      var slides = [].slice.call(car.querySelectorAll('.mc-carousel__slide'));
      if(slides.length < 2){ if(slides[0]) slides[0].classList.add('is-active'); var pa=car.querySelector('[data-mc-carousel-prev]'),na=car.querySelector('[data-mc-carousel-next]'); if(pa)pa.style.display='none'; if(na)na.style.display='none'; return; }
      var dotsWrap = car.querySelector('[data-mc-carousel-dots]');
      var idx = 0, timer = null;
      var dots = slides.map(function(_,i){
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'mc-carousel__dot'; d.setAttribute('aria-label','Foto '+(i+1));
        d.addEventListener('click', function(){ go(i, true); });
        if(dotsWrap) dotsWrap.appendChild(d);
        return d;
      });
      function paint(){
        slides.forEach(function(s,i){
          var on = i===idx;
          s.classList.toggle('is-active', on);
          var v = s.querySelector('video');
          if(v){ if(on){ var p=v.play(); if(p&&p.catch){p.catch(function(){});} } else { v.pause(); } }
        });
        dots.forEach(function(d,i){ d.classList.toggle('is-active', i===idx); });
        if(isAnat){ setActiveLayer(idx); }
      }
      function go(n, manual){ idx = (n + slides.length) % slides.length; paint(); restart(); }
      function next(){ go(idx+1); }
      function restart(){ if(timer){ clearInterval(timer); timer=null; } timer = setInterval(next, 5000); }
      var pv = car.querySelector('[data-mc-carousel-prev]'), nx = car.querySelector('[data-mc-carousel-next]');
      if(pv) pv.addEventListener('click', function(){ go(idx-1, true); });
      if(nx) nx.addEventListener('click', function(){ go(idx+1, true); });
      var x0 = null;
      car.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive:true});
      car.addEventListener('touchend', function(e){ if(x0===null) return; var dx = e.changedTouches[0].clientX - x0; if(Math.abs(dx)>40){ go(dx<0 ? idx+1 : idx-1, true); } x0 = null; }, {passive:true});
      car.addEventListener('mouseenter', function(){ if(timer) clearInterval(timer); });
      car.addEventListener('mouseleave', restart);
      if(isAnat){ anatCar = { goTo: function(n){ go(n, true); } }; }
      paint(); restart();
    });
  }

  function safe(fn){ try { fn(); } catch(e){ if(window.console) console.error('[mc-reclinables]', e); } }
  safe(resolveUrls);
  safe(renderSelector);
  safe(renderLayers);
  safe(renderReels);
  safe(initCarousels);

  function hydratePrices(){
    MODELS.forEach(function(m, i){
      var handle = handleOf(m.url || "");
      if(!handle) return;
      fetchProduct(handle).then(function(prod){
        if(typeof prod.price === 'number'){ m.now = Math.round(prod.price/100); }
        if(typeof prod.compare_at_price === 'number' && prod.compare_at_price > prod.price){ m.was = Math.round(prod.compare_at_price/100); }
        else { m.was = 0; }
        renderBars();
        if(i === state.model){ renderDetail(); }
      }).catch(function(){});
    });
  }
  safe(hydratePrices);
})();
